import { Outlet } from "react-router-dom";

type Props = {};

const UploadImageData = (props: Props) => {
  return <Outlet />;
};

export default UploadImageData;
